<div class="wait-modal">
    <div class="wait-modal__content">
        <ng-lottie [options]="animation"></ng-lottie>
    </div>
</div>
